module.exports = __webpack_public_path__ + "img/logo-card-contact-back.a5223924.jpg";